export const isString = (val: any) => {
  if (val.includes('.')) {
    return true;
  }
  if (val.length === 1 && val === ' ') {
    return false;
  }
  if (val[val.length - 1] === ' ' && val[val.length - 1] !== val[val.length - 2]) {
    return true;
  }
  if (
    val[val.length - 1]?.trim()?.toLowerCase() !== val[val.length - 1]?.trim()?.toUpperCase() ||
    val === ''
  ) {
    return true;
  }
  return false;
};
export const isFloat = (val: any) => {
  if (val[val.length - 1] === ' ' || val === '.' || val === '0') {
    return false;
  }
  if (val.includes('.')) {
    val = val.replace('.', '');
    // eslint-disable-next-line no-restricted-globals
    if ((!val.includes('.') && !isNaN(val?.trim())) || val === '') {
      return true;
    }
    return false;
  }
  // eslint-disable-next-line no-restricted-globals
  if (!isNaN(val?.trim()) || val === '') {
    return true;
  }
  return false;
};
export const isNumber = (val: any) => {
  if (val[val.length - 1] === ' ') {
    return false;
  }
  if (val.includes('.')) {
    return false;
  }
  // eslint-disable-next-line no-restricted-globals
  if (!isNaN(val?.trim()) || val === '') {
    return true;
  }
  return false;
};

export const isValidInput = (value: string) => {
  if (value === '') {
    return true;
  }
  if (value.trim() === '') {
    return false; // Reject if the value is empty or only consists of whitespace
  }

  if (value.includes('  ') || value.includes('..')) {
    return false; // Reject if there are consecutive spaces or decimals
  }

  return true; // Accept the input if it meets all the conditions
};

export const validateUAEIBAN = (iban: string, checkChecksum: boolean = true): { valid: boolean; error?: string; normalized?: string } => {
  if (!iban || iban.trim() === '') {
    return { valid: false, error: "Please enter a valid UAE IBAN. IBAN must contain exactly 23 characters and start with AE." };
  }

  const normalizedIBAN = iban.replace(/\s+/g, '').toUpperCase();

  if (normalizedIBAN.length !== 23 || !normalizedIBAN.startsWith('AE')) {
    return { valid: false, error: "Please enter a valid UAE IBAN. IBAN must contain exactly 23 characters and start with AE." };
  }

  if (!/^[A-Z0-9]+$/.test(normalizedIBAN)) {
    return { valid: false, error: "Please enter a valid UAE IBAN. IBAN must contain exactly 23 characters and start with AE." };
  }

  const rearranged = normalizedIBAN.substring(4) + normalizedIBAN.substring(0, 4);
  let numericIBAN = '';
  
  for (let i = 0; i < rearranged.length; i++) {
    const charCode = rearranged.charCodeAt(i);
    if (charCode >= 65 && charCode <= 90) {
      numericIBAN += (charCode - 55).toString();
    } else {
      numericIBAN += rearranged.charAt(i);
    }
  }

  let remainder = 0;
  for (let i = 0; i < numericIBAN.length; i++) {
    const digit = parseInt(numericIBAN.charAt(i), 10);
    remainder = (remainder * 10 + digit) % 97;
  }

  // Temporarily bypassed checksum check for testing purposes as requested by user
  // if (checkChecksum && remainder !== 1) {
  //   return { valid: false, error: "Please enter a valid IBAN." };
  // }

  return { valid: true, normalized: normalizedIBAN };
};

